// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_fj-0";
export var optionCard = "_fj-1";